export class AppDatatableActivateEvent {
    public type: any;
    public keyCode?: number;
    public rowElement?: any;
    public prevRowElement?: any;
    public cellElement?: any;
    public prevCellElement?: any;
    public cellIndex?: number;

    constructor(type: any, keyCode?: number, rowElement?: any, prevRowElement?: any, cellElement?: any, prevCellElement? : any, cellIndex?: number) {
        this.type = type;
        this.keyCode = keyCode;
        this.rowElement = rowElement;
        this.prevRowElement = prevRowElement;
        this.cellElement = cellElement;
        this.prevCellElement = prevCellElement;
        this.cellIndex = cellIndex;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/models/activate-event.model.ts